import React from 'react';
import { X, Mail, Phone, Building2, Download } from 'lucide-react';

const CONTACT = {
  name: 'Avinash Suthar',
  company: 'PM Infocom',
  email: 'sutharavinash27@gmail.com',
  phone: '9998045052',
};

function downloadVCard() {
  const vcard = [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `FN:${CONTACT.name}`,
    `ORG:${CONTACT.company}`,
    `EMAIL:${CONTACT.email}`,
    `TEL;TYPE=CELL:${CONTACT.phone}`,
    'END:VCARD',
  ].join('\n');
  const blob = new Blob([vcard], { type: 'text/vcard' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${CONTACT.name.replace(/\s+/g, '_')}.vcf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export default function DeveloperContactCard({ open, onClose }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={`Contact card for ${CONTACT.name}`}
    >
      <div
        className="w-full max-w-sm bg-white rounded-2xl shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative bg-gradient-to-br from-[color:var(--brand)] to-[color:var(--brand-2)] pt-8 pb-10 px-6">
          <button
            onClick={onClose}
            aria-label="Close"
            className="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center transition-colors z-10"
          >
            <X size={16} className="text-white" />
          </button>
        </div>

        <div className="px-6 pb-6">
          <div className="bg-white rounded-xl shadow-md border border-slate-100 p-5 pt-14 -mt-10 relative text-center">
            <img
              src="/images/avinash-suthar.jpg"
              alt={CONTACT.name}
              className="w-20 h-20 rounded-full object-cover shadow-lg ring-4 ring-white absolute left-1/2 -translate-x-1/2 -top-10"
            />
            <h3 className="text-xl font-bold text-[color:var(--ink)] leading-tight">{CONTACT.name}</h3>
            <div className="flex items-center justify-center gap-2 text-sm text-[color:var(--muted)] mt-1">
              <Building2 size={14} /> {CONTACT.company}
            </div>

            <div className="mt-4 space-y-2.5 text-sm text-left">
              <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 p-2.5 rounded-lg hover:bg-slate-50 transition-colors group">
                <span className="w-9 h-9 rounded-full bg-[color:var(--brand-soft)]/40 text-[color:var(--brand)] flex items-center justify-center shrink-0">
                  <Mail size={16} />
                </span>
                <span className="text-[color:var(--ink)] group-hover:text-[color:var(--brand)] break-all">{CONTACT.email}</span>
              </a>
              <a href={`tel:${CONTACT.phone}`} className="flex items-center gap-3 p-2.5 rounded-lg hover:bg-slate-50 transition-colors group">
                <span className="w-9 h-9 rounded-full bg-[color:var(--brand-soft)]/40 text-[color:var(--brand)] flex items-center justify-center shrink-0">
                  <Phone size={16} />
                </span>
                <span className="text-[color:var(--ink)] group-hover:text-[color:var(--brand)]">{CONTACT.phone}</span>
              </a>
            </div>

            <button
              onClick={downloadVCard}
              className="mt-5 w-full h-11 rounded-lg border border-[color:var(--brand)] text-[color:var(--brand)] text-sm font-medium hover:bg-[color:var(--brand-soft)]/30 transition-colors flex items-center justify-center gap-2"
            >
              <Download size={15} /> Save Contact
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
